import { render, staticRenderFns } from "./RedeRoute.vue?vue&type=template&id=1baceef6"
import script from "./RedeRoute.vue?vue&type=script&lang=js"
export * from "./RedeRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports